import React from 'react';
import Hero from './../components/Hero';
import SectionTitle from './../components/SectionTitle';
import ServicesMenu from './../components/ServicesMenu';
import Service from './../components/Service';

import { Grid } from "react-bootstrap";

class Services extends React.Component{
    render(){
        return(
            <Grid fluid>
                <Hero title={"Servicios"} />
                <SectionTitle title={'Paquetes'} />
                <ServicesMenu />
                <Service />
            </Grid>
        )
    }
}

export default Services;


// WEBPACK FOOTER //
// ./src/containers/Services.js